import styled from 'styled-components'

export const FourZeroFourMessage = styled.p`
  font-size: 34px;
  font-weight: 700;
`
